<template>
  <div class="page padding">
    <b-row>
      <b-col sm="9" lg="10">
        <b-alert show variant="info"> Para consultas acerca de Siniestros de RC Profesional, comuníquese con la Cía. </b-alert>
      </b-col>
      <b-col sm="2" xs="12" class="text-right">
        <b-dropdown variant="success" text="Nueva Denuncia" class="m-2 nueva-denuncia" no-caret>
          <b-dropdown-item v-if="!$role(['grupo norte'])" href="https://www.jotform.com/elimed/formulario-de-denuncia-ap" target="_blank">Accidentes Personales</b-dropdown-item>
          <b-dropdown-item href="https://www.jotform.com/elimed/formulario-de-denuncia-rc" target="_blank">Responsabilidad Civil</b-dropdown-item>
          <b-dropdown-item v-if="!$role(['grupo norte'])" href="https://www.jotform.com/elimed/formulario-de-denuncia-vida" target="_blank">Vida</b-dropdown-item>
          <b-dropdown-item v-if="!$role(['grupo norte'])" href="https://form.jotformz.com/elimed/formulario-denuncia-patrimoniales" target="_blank">Resto De Ramos</b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <b-card no-body v-if="!$role(['grupo norte'])">
      <b-card-header>Consulta de Siniestros</b-card-header>
      <form class="p-3" action @submit="()=>false">
        <b-row>
          <b-col sm="3">
            <b-form-group label="Ramo">
              <!-- Usuario del Grupo Norte no puede elegir otro ramo que RC PROF -->
              <b-form-input v-if="$role(['grupo norte'])" disabled value="RC PROF"></b-form-input>
              <!-- El resto de los usuarios -->
              <b-form-select :options="ramos" v-model="ramo" v-else></b-form-select>
            </b-form-group>
          </b-col>          
          <b-col sm="4" v-if="!$role(['productor'])">
            <b-form-group label="Productor">              
              <v-select :options="productores" 
                        label="text"
                        v-model="prodorg" 
                        @enter="getSiniestros(false)" />
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group label="Tomador o Asegurado">
              <finder v-model="terms" @enter="getSiniestros(false)" />
            </b-form-group>
          </b-col>
          <b-col sm="2">
            <b-tooltip target="aceptarbtn" triggers="hover" v-if="prodorg && prodorg.text == 'Todos'">          
              Tenga en cuenta que generar la consulta con la opcion "Todos" puede demorar más de lo previsto.<br>
              Por favor espere a que el proceso finalice.
            </b-tooltip>
            <b-btn id="aceptarbtn" class="mt-inline-form" variant="primary" block @click="getSiniestros(false)" :disabled="loading">Aceptar</b-btn>
          </b-col>
        </b-row>
      </form>
    </b-card>
    <sinies-table v-if="loading || totalRows" :loading="loading" :data="data" :date-from="date_from" :date-to="date_to" :rows-per-page="rowsPerPage" :total-rows="totalRows" @export="download" />
  </div>
</template>

<script>
import Finder from '@/components/Finder';
import SiniesTable from '@/components/Siniestros/SiniesTable';
import moment from 'moment';
import downloadDatatable from '@/helpers/download-datatable';
import { columns } from './helpers';

export default {
  name: 'SiniestrosIndex',
  components: {
    Finder,
    SiniesTable,
  },
  data() {
    return {
      date_from: moment().subtract(60, 'days').format('Y-MM-DD'),
      date_to: moment().format('Y-MM-DD'),
      data: [],
      rowFrom: 0,
      rowsPerPage: 10,
      totalRows: 0,
      ramo: 0,
      terms: '',
      prodorg: {text: 'Todos', value:null},
      loading: false,
    };
  },
  methods: {
    getSiniestros: async function () {
      this.data = [];      

      const payload = {
        terms: this.terms,
        ramo: this.ramo,
        prodorg: (this.prodorg && this.prodorg.hasOwnProperty('value'))?this.prodorg.value:null,
        cod_agente: this.$store.state.auth.cod_agente,
      };

      if (!this.$role(['productor']) && this.prodorg == null){        
        this.$toast.error('Seleccione una opcion en "Productor" para poder continuar.', 'Atencion.');
        return;
      }

      this.loading = true;

      if (this.$role(['organizador'])) {
        payload.productores_asociados = this.productores.map((p) => parseInt(p.value));
      }

      await this.$api
        .post('siniestros', payload)
        .then((res) => {
          this.data = res.data.results;
          this.totalRows = res.data.total_rows;
          if (this.totalRows == 0) this.$toast.warning('No hay registros disponibles para esta consulta.', 'Atencion.');
        })
        .catch((err) => {
          console.error(err.message);
        });

      this.sending = false;
      this.loading = false;
    },
    exportToExcel: async function (nombreArchivo, cols) {
      const loading = this.$loading.show();
      const payload = {
        terms: this.terms,
        ramo: this.ramo,
        prodorg: (this.prodorg && this.prodorg.hasOwnProperty('value'))?this.prodorg.value:null,
        cod_agente: this.$store.state.auth.cod_agente,
        cols: cols,
        excel: true,
      };

      if (this.$role(['organizador'])) {
        payload.productores_asociados = this.productores.map((p) => p.value);
      }

      await this.$api({
        method: 'POST',
        url: 'siniestros',
        data: payload,
        responseType: 'blob',
        headers: {
          ContentType: 'multipart/form-data',
        },
      })
        .then((res) => {
          const fileURL = URL.createObjectURL(res.data);
          const link = document.createElement('a');
          link.setAttribute('href', encodeURI(fileURL));
          link.setAttribute('download', nombreArchivo);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          loading.hide();
        })
        .catch((err) => {
          const toast = this.$toast;
          const fr = new FileReader();
          fr.onload = function () {
            toast.error(fr.result);
          };
          fr.readAsText(err.response.data);
          loading.hide();
        });
    },
    download: async function (fileExt, cols) {

      let codAgente = ''
      if (this.$role(['empleado interno']) || this.$role(['organizador'])) {
        codAgente = 'GENERAL'
      }else{
        codAgente = this.$store.state.auth.cod_agente
      }

      let ramoElegido = this.ramos.filter(e => e.value == this.ramo)

      let ramoElegidoTxt = ramoElegido[0].value == 0 ? '' : '-' + ramoElegido[0].text

      let nombreArchivo = codAgente + '-SINIESTROS' + ramoElegidoTxt + '.' + fileExt

      if (fileExt === 'xls') {
        return this.exportToExcel(nombreArchivo, cols);
      } else {
        downloadDatatable(this.data, columns.filter(x=> cols.includes(x.key)), nombreArchivo);
      }
    },
  },
  computed: {
    ramos() {
      return this.$store.getters['ramos'].filter((r) => r.value != 80 && r.value != 81);
    },
    productores() {      
      if (this.$store.state.auth.cod_agente){
        let p = this.$store.getters['productores'].filter(x => x.value != this.$store.state.auth.cod_agente);
        p.unshift({text: 'Todos', value:null});
        return p;
      }        
      else{
        let p = this.$store.getters['productores'].filter(x => x.value);
        p.unshift({text: 'Todos', value:null});
        return p;
      }
        
    },
  },
};
</script>

<style scoped>
.nueva-denuncia {
  width: -webkit-fill-available;
}
</style>
